'use client';
import React, { useRef } from 'react';
import Slider from 'react-slick';
import LazyLoadImage from '@repo/ui/src/components/LazyLoadImage';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { ImageProps } from '@repo/ui/src/types';
import { LeftArrow, RightArrow } from './CarouselArrows';

interface Props {
  asset: { image?: ImageProps }[];
  order: number;
  testID?: string;
}

const ImageSlide = (props: { image?: ImageProps }) => {
  const { image } = props;
  const imgUrl = image ? buildImageSrc(image, 700, 4, 3) : null;
  return (
    <div className="d-flex justify-content-center img-container mx-2 mx-md-3">
      {imgUrl ? (
        <LazyLoadImage
          imgComponent={
            <img
              className="tw-rounded tw-w-full tw-max-w-full tw-max-h-[185px] sm:tw-max-h-[240px] md:tw-max-h-full"
              src={imgUrl}
            />
          }
        />
      ) : null}
    </div>
  );
};

const FullWidthAssetCarousel = ({ asset, order, testID }: Props) => {
  const sliderRef = useRef<Slider>(null);

  const next = () => {
    sliderRef.current?.slickNext();
  };

  const previous = () => {
    sliderRef.current?.slickPrev();
  };

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
  };

  return (
    <div
      className="row jumbotron d-flex white-background justify-content-center py-5 tw-overflow-hidden tw-relative"
      style={{ zIndex: order, width: '100%', margin: 0 }}
      data-test-id={`full_width_asset_carousel_${testID}`}
    >
      <div
        className="mr-3 tw-absolute tw-top-1/2 tw-left-[4%] tw-translate-y-1/2 tw-z-[1000]"
        onClick={previous}
      >
        <LeftArrow />
      </div>
      <div
        className="ml-4 tw-absolute tw-top-1/2 tw-right-[4%] tw-translate-y-1/2 tw-z-[1000]"
        onClick={next}
      >
        <RightArrow />
      </div>
      <div className="full-carousel-overflow">
        <Slider ref={sliderRef} {...settings}>
          {asset.map((item, i: number) => (
            <ImageSlide {...item} key={i} />
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default FullWidthAssetCarousel;
